import Vue from 'vue';
import VueRouter from 'vue-router';

import LoginComponent from '../components/Auth/login-component.vue';
import AppsView from '../components/Apps/apps-view.vue';
import ListAppsComponent from '../components/Apps/list-component.vue';
import AddAppComponent from '../components/Apps/create-component.vue';
import EditAppComponent from '../components/Apps/edit-component.vue';

import CategoryView from '../components/Categories/category-view.vue';
import ListCategoriesComponent from '../components/Categories/list-categories.vue';
import AddCategoryComponent from '../components/Categories/create-category.vue';
import EditCategoryComponent from '../components/Categories/edit-category.vue';

import LawView from '../components/Laws/law-view.vue';
import ListLawsComponent from '../components/Laws/list-laws.vue';
import AddLawComponent from '../components/Laws/create-law.vue';
import EditLawComponent from '../components/Laws/edit-law.vue';

import store from '../store';

Vue.use(VueRouter);

const requireAuth = (to, from, next) => {
  if (!store.getters['auth/isLoggedIn']) {
    next({
      path: '/login',
    });
  }

  next();
};

export default new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: LoginComponent,
    },

    {
      path: '/',
      component: AppsView,
      children: [
        {
          path: '',
          name: 'Apps',
          component: ListAppsComponent,
          beforeEnter: requireAuth,
        },
        {
          path: '/add',
          name: 'Add App',
          component: AddAppComponent,
          beforeEnter: requireAuth,
        },
        {
          path: '/:appId/edit',
          name: 'Edit App',
          component: EditAppComponent,
          beforeEnter: requireAuth,
        },
      ],
    },

    {
      path: '/apps/:appId/categories/',
      component: CategoryView,
      children: [
        {
          path: '',
          name: 'List Categories',
          component: ListCategoriesComponent,
          beforeEnter: requireAuth,
        },
        {
          path: 'add',
          name: 'Add Category',
          component: AddCategoryComponent,
          beforeEnter: requireAuth,
        },
        {
          path: ':categoryId/edit',
          name: 'Edit Category',
          component: EditCategoryComponent,
          beforeEnter: requireAuth,
        },
      ],
    },

    {
      path: '/apps/:appId/laws',
      component: LawView,
      children: [
        {
          path: '',
          name: 'List Laws',
          component: ListLawsComponent,
          beforeEnter: requireAuth,
        },
        {
          path: 'add',
          name: 'Add Law',
          component: AddLawComponent,
          beforeEnter: requireAuth,
        },
        {
          path: ':lawId/edit',
          name: 'Edit Law',
          component: EditLawComponent,
          beforeEnter: requireAuth,
        },
      ],
    },

  ],
});
